import { Sun, Moon } from 'lucide-react';
import { useTheme } from '../../hooks/useTheme';
import { ImagoIconButton } from './ImagoButton';

/**
 * ImagoThemeToggle - switches the document theme.
 *
 * Shows the theme you would switch TO, not the one you are in: a sun on dark,
 * a moon on light. Built on ImagoIconButton so it cannot drift from the other
 * icon controls in the header.
 *
 * @param {Object} props
 * @param {'sm' | 'md' | 'lg'} [props.size='md'] - 24 / 28 / 32px square
 * @param {string} [props.className]
 */
export function ImagoThemeToggle({ className = '', size = 'md', ...rest }) {
  const { theme, toggleTheme } = useTheme();

  const iconSize = { sm: 'w-4 h-4', md: 'w-4 h-4', lg: 'w-5 h-5' }[size] || 'w-4 h-4';
  const isDark = theme === 'dark';
  const label = isDark ? 'Switch to light theme' : 'Switch to dark theme';

  return (
    <ImagoIconButton
      size={size}
      label={label}
      onClick={toggleTheme}
      className={className}
      {...rest}
    >
      {isDark ? <Sun className={iconSize} /> : <Moon className={iconSize} />}
    </ImagoIconButton>
  );
}

export default ImagoThemeToggle;
